import { render, staticRenderFns } from "./Ubicaciones.vue?vue&type=template&id=7dc88d07&scoped=true"
import script from "./Ubicaciones.vue?vue&type=script&lang=js"
export * from "./Ubicaciones.vue?vue&type=script&lang=js"
import style0 from "./Ubicaciones.vue?vue&type=style&index=0&id=7dc88d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc88d07",
  null
  
)

export default component.exports